<template>
  <div>
    <div class="img-pred">
      <h2 style="color: #002856;">Bilderkennung</h2>
      <br />
      <b-card-group deck>
        <b-card img-src="./../assets/image_pred.png" img-alt="Card image" img-top>
          <b-card-text>Im Bereich Bilderkennung dominieren Neuronale Netze das Feld. Um an ein Modell zu kommen, das Vorhersagen treffen kann, muss man in einem ersten Schritt das Neuronale Netz mit Trainingsdaten füttern. Somit lernt das Modell dir die richtigen Parameter nur anhand der Trainingsbilder. Nachdem das Modell abgespeichert wurde, kann man damit Vorhersagen machen zu neuen Bildern.</b-card-text>
        </b-card>
        <b-card img-alt="Card image">
          <br />
          <b-card-text>Hier haben Sie die Möglichkeit die Bilderkennung zu testen. Sie können ein Bild hochladen oder per "Drag & Drop" einfügen. Danach nur noch auf "Senden" drücken und warten. Es werden Ihnen fünf Kategorien angezeigt, welche der Wahrscheinlichkeit in absteigender Reihenfolge sortiert sind.</b-card-text>
          <br />
          <br />
          <div class="file-upload">
            <b-form-file
              type="file"
              id="file"
              ref="file"
              v-model="file"
              :state="Boolean(file)"
              accept="image/*"
              placeholder="Bild auswählen oder Drag & Drop..."
              @change="functionWrapper"
            ></b-form-file>
          </div>
          <div class="image-preview" v-if="imageData.length > 0">
            <img class="preview" :src="imageData" />
          </div>
          <br />
          <button
            id="sub"
            type="button"
            class="btn btn-outline-success btn-lg"
            @click="submitFile()"
          >Senden</button>
          <br />
          <br />
          <template v-if="!showResultBars && buttonClicked">
            <b-spinner large type="grow" variant="success" label="Loading..." />
          </template>
          <template v-if="showResultBars">
            <PercentageBars :probabilities="response" />
          </template>
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import ShowPreds from "./ShowPreds";
import PercentageBars from "./PercentageBars";

export default {
  name: "SingleImgPred",
  components: {
    ShowPreds,
    PercentageBars
  },
  data() {
    return {
      showResultBars: false,
      file: "",
      imageData: "", // we will store base64 format of image in this string
      fileExtension: "",
      response: {},
      buttonClicked: false,
      apiBase: process.env.VUE_APP_ROOT_API,
      token: process.env.VUE_APP_API_TOKEN
    };
  },
  methods: {
    previewImage: function(event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    /*
        Submits the file to the server
      */
    submitFile() {
      if (this.file != "") {
        this.fileExtension = this.file["name"].split(".").pop();
        if (
          this.fileExtension == "jpg" ||
          this.fileExtension == "jpeg" ||
          this.fileExtension == "png"
        ) {
          let formData = new FormData();
          this.buttonClicked = true;
          formData.append("file", this.file);
          console.log(this.file);
          console.log(formData);

          axios
            .post(this.apiBase + "/predict/image/", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: this.token
              }
            })
            .then(response => {
              if (response.status == 200) {
                console.log("SUCCESS!!");
                console.log(response);
                this.response = response.data;
                this.showResultBars = true;
                console.log("showResultBars is :,", this.showResultBars);
              }
            })
            .catch(error => {
              console.log(error);
              this.buttonClicked = false;
              this.showResultBars = false;
              alert("An error has occured");
            });
        } else {
          alert("Supported image types are jpg/jpeg/png");
        }
      } else {
        alert("Please upload an image");
      }
    },
    handleFileUpload() {
      console.log("showResultBars changed");
      this.showResultBars = false;
      this.buttonClicked = false;
    },
    functionWrapper(event) {
      this.previewImage(event);
      this.handleFileUpload();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.img-input {
  margin: 50px 0px 0px 0px;
  padding: 5px;
  background: white;
}
.input-group {
  padding: 0px 0px 100px 0px;
}
.img-pred {
  color: black;
}
#sub {
  color: #002856;
  border-color: #002856;
}
.image-preview {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  padding: 20px;
}
img.preview {
  width: 200px;
  background-color: white;
  border: 1px solid #ddd;
  padding: 5px;
}
</style>
